$(document).ready(function () {
  $("#account-link").click(function () {
    if ($("#account-link").text() == "Sign In") {
      // close mobile nav
      $(".mobile-nav-container").removeClass("nav-slide");
      DK.modalShadowHide();
      // open login modal
      initLogin();
    } else {
      window.location.assign("/account");
    }
  });

  $("#wishlist-link").click(function () {
    if (DK.customer) {
      DK.set("wishlistScroll", false);

      window.location.assign("/pages/wishlist");
    } else {
      $("#account-link").trigger("click");
    }
  });

  function initLogin2() {
    DK.modalShadowShow();
    var top = $("#header").height();
    var aptop = $("#airplane").outerHeight();
    var st = $(window).scrollTop();
    var diff = aptop - st;
    if (diff < 0) diff = 0;
    top = top + diff;

    var logintpl =
      '<style>.wbox input{width: 300px;padding: 8px;border: 1px solid #b3b3b3;}.wbox-container{width:318px;margin:0 auto;}.wbox .forgot-pass:hover{cursor:pointer;text-decoration:underline;}.wbox .black-button{margin-top:24px;background-color:black;color:white;padding:8px;height:40px;font-size:14px;width:318px;text-transform:uppercase}.wbox .black-button:hover{cursor:pointer;opacity:0.7}.wbox h2{text-transform:uppercase;font-size:18px;}.wbox p{font-size:12px;}</style><div class="wbox-container"><h2 style="margin-top:80px;">Sign into your account</h2><input style="margin-top:24px;" type="text" id="email" placeholder="Email"><input style="margin-top:8px;" type="password" id="password" placeholder="Password"><button class="black-button" id="sign-in">Sign In</button><p style="margin-top:16px;" class="forgot-pass">Forgot your password?</p><p style="display:none;margin-top:16px;" class="red" id="login-error"></p><p style="margin:48px 0;border-top:1px solid black;">&nbsp;</p><h2>Not signed up yet?</h2><p style="margin-top:24px;">Sign up to checkout faster, track orders, create wishlists & more</p><p style="margin-top:8px;"><span style="width:33%;display:inline-block"><img src="//cdn.shopify.com/s/files/1/0634/6335/8721/t/1/assets/icon3.svg?v=65953629750879961921654893745"/><br/>Checkout Faster</span><span style="width:33%;display:inline-block"><img src="//cdn.shopify.com/s/files/1/0634/6335/8721/t/1/assets/Vector.svg?v=177774452175447916911654891641"/><br/>Wishlists</span><span style="width:33%;display:inline-block"><img src="//cdn.shopify.com/s/files/1/0634/6335/8721/t/1/assets/Fast-Delivery.svg?v=67189186323553349771654891636"/><br/>Order Tracking</span></p><p><button class="black-button" id="create-action">Create An Account</button></div>';
    $(".wbox")
      .show()
      .css("left", 0)
      .css("top", top + "px")
      .css("text-align", "center")
      .html(logintpl);

    $("#sign-in").click(function () {
      var email = $("#email").val();
      var pass = $("#password").val();
      var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      var isEmail = regex.test(email);
      var errortarget = $("#login-error");

      errortarget.html(" ").hide();

      if (isEmail) {
        if (email.length > 0) {
          if (pass.length > 0) {
            var test = DK.getQuery("checkout_url");
            if (!test) test = "";
            DK.api(
              "POST",
              "/customers",
              { dkemail: email, dkpass: pass, return_to: test },
              function (r) {
                if (r.status == 1) {
                  DK.set("em", email.toLowerCase());
                  var uri = "/account/login/multipass/" + r.token;
                  window.location.assign(uri);
                } else {
                  errortarget.html("Email/Password incorrect.").show();
                }
              }
            );
          } else {
            errortarget.html("Please enter a password.").show();
          }
        } else {
          errortarget.html("Please enter an email.").show();
        }
      } else {
        errortarget.html("Please enter an email.").show();
      }
    });

    $(".forgot-pass").click(function () {
      var email = $("#email").val();
      DK.api("POST", "/customers/recovery", { dkemail: email }, function (r) {
        if (r.status == 1) {
          var html =
            '<p data-test-id="v1--forgot-password-success" style="margin-top:10px;">We have sent instructions on how to reset your password to your email! Please follow the link to reset your password. <br /><br /><span style="text-decoration: underline; cursor: pointer" onclick="$(\'#overlay\').trigger(\'click\');">Click here to close this window</span></p>';
          $(".wbox-container").html(html);
        } else {
          $("#login-error").show().html("An error occured with your password recovery.");
        }
      });
    });

    $("#create-action").click(function () {
      var tpl =
        '<input style="margin-top:80px;" type="text" id="firstname" placeholder="First Name"><input style="margin-top:8px;" type="text" id="lastname" placeholder="Last Name"><input style="margin-top:8px;" type="text" id="email" placeholder="Email"><input style="margin-top:8px;" type="password" id="password" placeholder="Password"><button class="black-button" id="create-account">Create An Account</button><p class="red" id="creation-error" style="margin-top:24px;display:none;"></p>';
      $(".wbox-container").html(tpl);

      $("#create-account").click(function () {
        var errorDiv = $("#creation-error");
        var firstname = $("#firstname").val();
        var lastname = $("#lastname").val();
        var email = $("#email").val();
        var pass = $("#password").val();

        errorDiv.hide().html(" ");

        if (firstname.length > 0) {
          if (lastname.length > 0) {
            if (pass.length > 0) {
              if (email.length > 0) {
                DK.api(
                  "POST",
                  "/customers/new",
                  {
                    dkemail: email,
                    dkpass: pass,
                    dkfirstname: firstname,
                    dklastname: lastname,
                  },
                  function (r) {
                    if (r.status == 1) {
                      const options = {
                        method: "POST",
                        headers: {
                          revision: "2023-07-15",
                          "content-type": "application/json",
                        },
                        body: JSON.stringify({
                          data: {
                            type: "subscription",
                            attributes: {
                              profile: {
                                data: {
                                  type: "profile",
                                  attributes: {
                                    email: email,
                                  },
                                },
                              },
                            },
                            relationships: {
                              list: { data: { type: "list", id: "TSzhLM" } },
                            },
                          },
                        }),
                      };

                      fetch(
                        "https://a.klaviyo.com/client/subscriptions/?company_id=bFUiBy",
                        options
                      )
                        .then((response) => response.json())
                        .then((response) => console.log(response))
                        .catch((err) => console.error(err));

                      DK.set("em", email.toLowerCase());
                      window.location.assign("/account/login/multipass/" + r.token);
                    } else {
                      errorDiv.html(r.error_message).show();
                    }
                  }
                );
              } else {
                errorDiv.html("Email cannot be empty").show();
              }
            } else {
              errorDiv.html("Password cannot be empty").show();
            }
          } else {
            errorDiv.html("Last name cannot be empty").show();
          }
        } else {
          errorDiv.html("First name cannot be empty").show();
        }
      });
    });
  }

  function initLogin() {
    var logintpl =
      '<div style="width:100%;margin:0 auto;text-align:center" class="acctlogin"><h1>Account Login</h1><div id="account-content-area"><p style="padding-top:10px;">Enter your e-mail to login/create an account</p><div class="account-login" data-test-id="v1--login-form"><div class="field"><input type="email" class="f100" name="customer[email]" id="CustomerEmail" autocomplete="email" autocorrect="off" autocapitalize="off" placeholder="E-Mail Address"></div><p><button data-test-id="login-button" class="login-button">LOGIN</button></p><p class="hide red" id="email-error" data-test-id="v1--login-error">Please enter a valid email BB.</p></div></div>';
    DK.darkboxContent(logintpl, {
      background:
        "#000 url(https://cdn.shopify.com/s/files/1/0634/6335/8721/files/main-background.jpg?v=1694118930) no-repeat top center",
      "background-position": "50% 50%",
      "-webkit-background-size": "cover",
    });

    if (!DK.isMobile) $("#CustomerEmail").focus();

    $("#CustomerEmail").on("keypress", function (e) {
      if (e.which == 13) loginscreen();
    });

    $(".login-button").click(function () {
      loginscreen();
    });
  }

  function loginscreen() {
    $("#email-error").hide();
    var email = $("#CustomerEmail").val();
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    var isEmail = regex.test(email);
    if (isEmail) {
      if ($(".login-button").hasClass("loading-button")) return false;
      $(".login-button")
        .html('<i class="fa-solid fa-spinner fa-spin-pulse"></i> LOADING...')
        .addClass("loading-button");

      loginlocation = "login";
      if (typeof DK.loginContext == "string") loginlocation = DK.loginContext;
      DK.emailCapture(email, loginlocation);
      DK.api("POST", "/customers", { dkemail: email }, function (r) {
        if (r.status == 1) {
          passwordscreen(email);
        } else {
          displaycreation(email);
        }
        $(".login-button").html("LOGIN").removeClass("loading-button");
      });
    } else {
      $("#email-error").show();
    }
  }

  function displaycreation(email) {
    var logintpl =
      '<div id="account-content-area"><p style="padding-top:10px;">Create your account</p><div class="account-login" data-test-id="v1--create-account-form"><div class="field"><input class="f100" type="text" name="customer[first_name]" id="CustomerFirstName" placeholder="First Name"><input class="f100" type="text" name="customer[last_name]" id="CustomerLastName" placeholder="Last Name"><input class="f100" type="password" name="customer[password]" id="CustomerPassword" placeholder="Password"></div><p><button class="create-button">CREATE</button></p><p class="hide red" id="creation-error data-test-id="v1--create-account-error"></p></div>';
    $("#account-content-area").html(logintpl);
    $("#CustomerFirstName").focus();

    $("#CustomerPassword").on("keypress", function (e) {
      if (e.which == 13) postprofile(email);
    });

    $(".create-button").click(function () {
      postprofile(email);
    });
  }

  function postprofile(email) {
    var firstName = $("#CustomerFirstName").val();
    var lastName = $("#CustomerLastName").val();
    var password = $("#CustomerPassword").val();

    var errorDiv = $("#creation-error");
    errorDiv.hide();

    if (firstName.length > 0) {
      if (lastName.length > 0) {
        if (password.length > 0) {
          if ($(".create-button").hasClass("loading-button")) return false;
          $(".create-button")
            .html('<i class="fa-solid fa-spinner fa-spin-pulse"></i> CREATING...')
            .addClass("loading-button");
          DK.api(
            "POST",
            "/customers/new",
            {
              dkemail: email,
              dkpass: password,
              dkfirstname: firstName,
              dklastname: lastName,
            },
            function (r) {
              if (r.status == 1) {
                const options = {
                  method: "POST",
                  headers: {
                    revision: "2023-07-15",
                    "content-type": "application/json",
                  },
                  body: JSON.stringify({
                    data: {
                      type: "subscription",
                      attributes: {
                        profile: {
                          data: {
                            type: "profile",
                            attributes: {
                              email: email,
                            },
                          },
                        },
                      },
                      relationships: {
                        list: { data: { type: "list", id: "TSzhLM" } },
                      },
                    },
                  }),
                };

                fetch("https://a.klaviyo.com/client/subscriptions/?company_id=bFUiBy", options)
                  .then((response) => response.json())
                  .then((response) => console.log(response))
                  .catch((err) => console.error(err));

                DK.set("em", email.toLowerCase());
                window.location.assign("/account/login/multipass/" + r.token);
              } else {
                $(".create-button").html("CREATE").removeClass("loading-button");
                errorDiv.html(r.error_message);
              }
            }
          );
        } else {
          errorDiv.html("Password cannot be empty").show();
        }
      } else {
        errorDiv.html("Last name cannot be empty").show();
      }
    } else {
      errorDiv.html("First name cannot be empty").show();
    }
  }

  function passwordscreen(email) {
    $("h1", $("#darkbox")).html("Enter Your Password");
    var logintpl =
      '<div id="account-content-area"><p class="loginmessaging" style="padding-top:10px;">We found your OG account! Enter your password to login. If your password doesn\'t work, <span class="forgot-password" style="text-decoration: underline; cursor: pointer;">click here to reset</span>. Our website got a makeover and we\'re exxxcited to share our new lewk with you <3</p><div class="account-login"><div class="field"><input class="f100" type="password"a name="customer[password]" id="CustomerPassword" placeholder="Password"></div><p><button data-test-id="login-button" class="login-button">LOGIN</button></p><p class="red forgot-password" style="text-decoration:underline;cursor:pointer;">Forgot password?</p><p data-test-id="v1--login-error-password" class="hide red" id="password-error">Password is incorrect.</p><p data-test-id="v1--recovery-email-error" class="hide red" id="recovery-error">Error sending recovery email.</p></div>';
    $("#account-content-area").html(logintpl);
    $("#CustomerPassword").focus();

    $("#CustomerPassword").on("keypress", function (e) {
      if (e.which == 13) verifypassword(email);
    });

    $(".login-button").click(function () {
      verifypassword(email);
    });
    if ($(".forgot-password").hasClass("loading-button")) return false;
    $(".forgot-password").click(function () {
      $("#recover-email").hide();
      $(".forgot-password").addClass("loading-button");
      DK.api("POST", "/customers/recovery", { dkemail: email }, function (r) {
        if (r.status == 1) {
          var logintpl =
            '<p data-test-id="v1--forgot-password-success" style="padding-top:10px;">We have sent instructions on how to reset your password to your email! Please follow the link to reset your password. <br /><br /><span style="text-decoration: underline; cursor: pointer" onclick="$(\'#darkbox-header-closer\').trigger(\'click\');">Click here to close this window</span></p>';
          $("#account-content-area").html(logintpl);
        } else {
          $("#recover-email").show();
        }
        $(".forgot-password").removeClass("loading-button");
      });
    });
  }

  var recoverPass = false;
  var customeremail = false;
  var key = false;
  var pathParams = window.location.search;
  pathParams = pathParams.substring(1);
  pathParams = pathParams.split("&");
  $.each(pathParams, function () {
    var kv = this.split("=");
    var k = kv[0];
    var v = kv[1];
    if (k == "recoverpass") recoverPass = true;
    if (k == "ekey") {
      recoverPass = true;
      key = v;
    }
    if (k == "email") customerEmail = decodeURIComponent(v);
  });

  if (recoverPass) resetPass(key, customerEmail);

  function resetPass(key, email) {
    var tpl =
      '<div style="width:100%;margin:0 auto;text-align:center" class="acctlogin"><h1>Reset Your Password</h1><div id="account-content-area"><p style="padding-top:10px;">Choose a new password below, this will not create a new account.</p><div class="account-login" data-test-id="v1--reset-password-form"><div class="field"><input type="password" class="f100" name="customer[password]" id="CustomerPassword" autocorrect="off" autocapitalize="off" placeholder="Password"></div><div class="field"><input type="password" class="f100" name="customer[passwordconfirm]" id="CustomerPasswordConfirm" autocorrect="off" autocapitalize="off" placeholder="Password Confirm"></div><p><button data-test-id="login-button" class="login-button">UPDATE PASSWORD</button></p><p data-test-id="v1--reset-password-match-error" class="hide red" id="password-error">Both passwords should match.</p></div></div>';
    DK.darkboxContent(tpl, {
      background:
        "#000 url(https://cdn.shopify.com/s/files/1/0634/6335/8721/files/main-background.jpg?v=1694118930) no-repeat top center",
      "background-position": "50% 50%",
      "-webkit-background-size": "cover",
    });

    var errortarget = $("#password-error");

    $(".login-button").click(function () {
      errortarget.hide();
      var pass = $("#CustomerPassword").val();
      var cpass = $("#CustomerPasswordConfirm").val();

      if (pass.length > 0) {
        if (cpass.length > 0) {
          if (pass == cpass) {
            DK.api(
              "PATCH",
              "/customers",
              { np: pass, apikey: key, email: email },
              function (patch) {
                if (patch.status == 1) {
                  DK.set("em", email.toLowerCase());
                  $("#account-content-area").html(
                    "Successfully updated your password, redirecting you now..."
                  );
                  window.setTimeout(function () {
                    window.location.assign("/account/login/multipass/" + patch.token);
                  }, 900);
                } else {
                  var errormessage = "There was an error updating your password.";
                  if (typeof patch.error_message !== "undefined")
                    errormessage = patch.error_message;
                  errortarget.html(errormessage).show();
                }
                $("#update-password-button").html("UPDATE").removeClass("loading-button");
              }
            );
          } else {
            errortarget.show().html("Password and password confirmation should match.");
          }
        } else {
          errortarget.show().html("Please enter a password confirmation");
        }
      } else {
        errortarget.show().html("Please enter a password");
      }
    });
  }

  function verifypassword(email) {
    var password = $("#CustomerPassword").val();
    $("#password-error").hide();
    if (password.length > 0) {
      if ($(".login-button").hasClass("loading-button")) return false;
      $(".login-button")
        .html('<i class="fa-solid fa-spinner fa-spin-pulse"></i> LOADING...')
        .addClass("loading-button");
      var test = DK.getQuery("checkout_url");
      if (!test) test = "";

      if (DK.get("maybe_wishlist_item")) test = window.location.href;
      DK.api(
        "POST",
        "/customers",
        { dkemail: email, dkpass: password, return_to: test },
        function (r) {
          if (r.status == 1) {
            DK.set("em", email.toLowerCase());
            var uri = "/account/login/multipass/" + r.token;
            window.location.assign(uri);
          } else {
            $("#password-error").show();
            $("#CustomerPassword").val("").focus();
          }
          $(".login-button").text("LOGIN").removeClass("loading-button");
        }
      );
    }
  }

  $("span.jss25").click(function () {
    DK.renderCart();
  });

  var gbe = 1;
  if (gbe) {
  } else {
    $(".localization").click(function () {
      var tgt = $("#localization-options");
      var lico = $("#l-icon");

      if (tgt.attr("data-status") == 0) {
        lico.removeClass("fa-chevron-down").addClass("fa-chevron-up");
        tgt.show();
        tgt.attr("data-status", 1);
      } else {
        lico.removeClass("fa-chevron-up").addClass("fa-chevron-down");
        tgt.hide();
        tgt.attr("data-status", 0);
      }
    });

    $("span[data-country-code]").click(function () {
      var cc = $(this).attr("data-country-code");
      $("input[name=country_code]").val(cc);

      $("#localeform").submit();
    });
  }
  DK.lock = false;
  /*$(window).scroll(function() {
    var top = $(window).scrollTop();
    if (top > 10) {
      $('#skinny').slideUp();
      $('.rb-menu').slideUp();
      $('#airplane').slideUp();
      $('.xlogo').addClass('smaller');
      $('.navigation-wrapper').addClass('smaller');
      $('.nav-icons').addClass('smaller');
      $('#header-expanded').addClass('smaller');
      $('#header').addClass('stick');
    }
    else if (top == 0) {
      if (!DK.lock) {
                DK.lock = true;
              $('#skinny').slideDown('fast');
              $('#airplane').slideDown('fast');
              $('.rb-menu').slideDown('fast');
              $('.xlogo').removeClass('smaller');
              $('.navigation-wrapper').removeClass('smaller');
              $('.nav-icons').removeClass('smaller');
              $('#header-expanded').removeClass('smaller');
              $('#header').removeClass('stick');
        window.setTimeout(function() {
          DK.lock = false;
        },1000);
      }
    }
  });*/

  var c = Shopify.country;
  var market = c;
  DK.globalBanners(market);
  DK.airplanes(market);

  svg =
    "https://cdn.shopify.com/s/files/1/0634/6335/8721/t/1/assets/" +
    c.toLowerCase() +
    ".svg?v=1669926860";

  $("object[data-current-flag]").attr("data", svg);

  var gbe = 1;
  if (gbe) {
    $("span", $(".localization")).html(c + ' <i class="fa fa-chevron-right"></i>');
  } else {
    $("span", $(".localization")).prepend(Shopify.currency.active + " ");
  }
  dataLayer.push({ event: "pageview" });

  if (typeof triggerAccount == "boolean") {
    $("#account-link").trigger("click");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // this click event fixes a safari bug that causes closing modals
  // to jump a user to the next input, moving them down the page
  document.addEventListener("click", function(e) {
    let { target } = e;
    while (target && target !== document && target !== null) {
      // if a user is clicking on an input, we don't want to blur it
      if (target.nodeName === "INPUT") {
        break;
      }
      // The modal we are looking for is coming from amped
      // and can be targeted looking for the ampedType attribute
      if (!!target.dataset?.ampedType) {
        document.activeElement.blur();
        break;
      } else {
      // If the target is not the modal, we move up the tree
        target = target?.parentElement;
      }
    }
  })
  const skinnyBanner = document.querySelector(".skinny-banner");
  const skinnyBannerHeight = skinnyBanner ? skinnyBanner.offsetHeight : 0;
  document.documentElement.style.setProperty("--skinny-banner-height", `${skinnyBannerHeight}px`);

  const setDataHeaderHeight = () => {
    const dataHeader = document.querySelector("section[data-header]");
    const dataHeaderHeight = dataHeader ? dataHeader.offsetHeight : 0;
    document.documentElement.style.setProperty("--data-header-height", `${dataHeaderHeight}px`);
  };

  setDataHeaderHeight();

  window.addEventListener("resize", setDataHeaderHeight);

  document.querySelector("body").classList.remove("tw-opacity-0");
});
